{
	"title": "Systeemstatus",
	"api": "API",
	"database": "Database",
	"serverTime": "Servertijd",
	"status": {
		"ok": "In orde",
		"degraded": "Verstoord"
	},
	"databaseStatus": {
		"ok": "Bereikbaar",
		"unavailable": "Niet bereikbaar"
	},
	"help": {
		"health": {
			"title": "Systeemstatus",
			"area": "Start › Systeemstatus",
			"short": "Of het beheer zijn gegevens bereikt. De API is in orde zolang de database bereikbaar is. De servertijd is de Nederlandse tijd waarmee de API rekent.",
			"choices": [
				{
					"name": "In orde",
					"text": "De API en de database werken."
				},
				{
					"name": "Verstoord",
					"text": "De database is niet bereikbaar: het beheer kan niets lezen of opslaan. Kijk over een paar minuten opnieuw, en meld het als het blijft."
				}
			],
			"warning": "De shop zelf wordt hier niet gecontroleerd. Twijfel je of de shop werkt, open hem dan en kijk."
		}
	}
}
